import classNames from './PayAttention.module.scss';
import mineClassNames from '../DeleteTeacherModal.module.scss';
import { Trans } from 'react-i18next';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import TheButton from '@/components/school-management/TheButton/TheButton';

interface PayAttentionProps {
  teacherName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const PayAttention = ({ teacherName, onConfirm, onCancel }: PayAttentionProps) => {
  const { t } = useAdminTranslation();

  return (
    <div className={classNames.content}>
      <span className={classNames.warningIcon}>⚠️</span>
      <h2>{t('schoolDetailsPage.classes.deleteTeacherModal.payAttention.title')}</h2>
      <span className={classNames.description}>
        <Trans
          ns='admin'
          i18nKey='schoolDetailsPage.classes.deleteTeacherModal.payAttention.description'
          values={{ teacherName }}
          components={{ strong: <strong /> }}
        />
      </span>
      <div className={mineClassNames.buttonsContainer}>
        <TheButton
          className={mineClassNames.confirmBtn}
          text={t('schoolDetailsPage.classes.deleteTeacherModal.continue')}
          shouldRecolor={false}
          emitOnClick={onConfirm}
        />
        <TheButton
          className={mineClassNames.cancelBtn}
          text={t('schoolDetailsPage.classes.deleteTeacherModal.cancel')}
          plain
          shouldRecolor={false}
          emitOnClick={onCancel}
        />
      </div>
    </div>
  );
};

export default PayAttention;
